import { useAnalytics } from 'ia-react-core';
import { useCallback } from 'react';
import { RenderResult, RenderSuccessCallback } from '@okta/okta-signin-widget';
import logger from '../../../utils/logger';
import { getRedirectUrl } from './getRedirectUrl';

const useHandleOnSuccess = (): RenderSuccessCallback => {
  const { track } = useAnalytics();
  const useHandleOnSuccessCall = useCallback((res: RenderResult) => {
    if (res.status === 'SUCCESS') {
      const redirectURL = getRedirectUrl();
      res.session.setCookieAndRedirect(redirectURL);
      logger.info(`Authentication success. Username: ${res.user.profile.login}`);
      const trackOption = { event: new MouseEvent('click', {}), scope: 'Sign In', values: { login: 'success' } };
      track(trackOption);
      sessionStorage.setItem('isAuthenticated', 'true');
    } else {
      // TODO: Handle other status
      // https://github.com/okta/okta-signin-widget#success
      logger.error(`Authentication returned status ${res.status}`);
    }
  }, [track]);

  return useHandleOnSuccessCall;
};

export default useHandleOnSuccess;
